/* mixins/blockUI */
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters([
            'getBlockUIShow',
            'getBlockUIMessage'
        ])
    },

    methods: {
        ...mapActions([
            'setBlockUIHide',
            'setBlockUIMessage',
            'setBlockUIShow'
        ]),

        hideBlockUI() {
            this.setBlockUIHide()
        },

        setBlockUI(message) {
            this.setBlockUIMessage(message)
        },

        showBlockUI() {
            this.setBlockUIShow()
        }
    }
}